/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloudAccount
 */
export interface CloudAccount {
    /**
     * 
     * @type {number}
     * @memberof CloudAccount
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CloudAccount
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CloudAccount
     */
    provider?: CloudAccountProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof CloudAccount
     */
    accessId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccount
     */
    secret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccount
     */
    tenant?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccount
     */
    subscription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccount
     */
    endpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudAccount
     */
    mountCredentialsManagement?: CloudAccountMountCredentialsManagementEnum;
}

/**
* @export
* @enum {string}
*/
export enum CloudAccountProviderEnum {
    Azure = 'azure',
    Aws = 'aws',
    Backblaze = 'backblaze',
    Gcloud = 'gcloud'
}/**
* @export
* @enum {string}
*/
export enum CloudAccountMountCredentialsManagementEnum {
    Null = 'null',
    Share = 'share',
    Token = 'token'
}

export function CloudAccountFromJSON(json: any): CloudAccount {
    return CloudAccountFromJSONTyped(json, false);
}

export function CloudAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'accessId': !exists(json, 'access_id') ? undefined : json['access_id'],
        'secret': !exists(json, 'secret') ? undefined : json['secret'],
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'subscription': !exists(json, 'subscription') ? undefined : json['subscription'],
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'mountCredentialsManagement': !exists(json, 'mount_credentials_management') ? undefined : json['mount_credentials_management'],
    };
}

export function CloudAccountToJSON(value?: CloudAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'provider': value.provider,
        'access_id': value.accessId,
        'secret': value.secret,
        'tenant': value.tenant,
        'subscription': value.subscription,
        'endpoint': value.endpoint,
        'mount_credentials_management': value.mountCredentialsManagement,
    };
}


